<template>
  <div>
    <div class="dash-header">
      <div class="dash-header-inner">
        <div class="welcome">
          <template>
            <router-link to="/" class="dash-head-logo">
              <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/logo.png" />
            </router-link>
          </template>
        </div>
        <nav>
          <div class="nav-login-info login-info v-clearfix">
            <template v-if="isLogin">
              <span>{{ name || loginAccount || '--' }}</span>
              <a href="javascript:void(0)" @click="LogOut">{{ $t('logout') }}</a>
              <span class="line-mar">|</span>
            </template>
            <router-link to="/login/person" v-else>{{ $t('registerLogin') }}</router-link>
            <span class="head-roles" v-if="isLogin"><i>{{ $t('finds.currentUser') }}：</i>
              <font>{{ subjectType == 'VISITOR' ? $t('actor') : $t('exhibitors') }}</font>
            </span>
          </div>
          <li class='el-menu-iconfont language-change'>
            <i class="iconfont iconicon_A" @click="setLang('en')" v-if="language === 'zh'"></i>
            <i class="iconfont iconyuyanqiehuancon" @click="setLang('zh')" v-if="language === 'en'"></i>
          </li>
        </nav>
      </div>
    </div>
    <advertisementVertical :option="$config.advertisement.leftList.workList" :leftPosition='true'
      :top="advertisementTop+'px'"></advertisementVertical>
    <advertisementVertical :option="$config.advertisement.rightList.workList" :rightPosition='true'
      :top="advertisementTop+'px'"></advertisementVertical>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import advertisementVertical from '@/components/advertisementVertical'

export default {
  name: 'DashHeader',
  components: {
    advertisementVertical
  },
  data() {
    return {
      advertisementTop: 98,
      activeIndex: '/invite',
      name: ''
    }
  },
  computed: {
    ...mapGetters(['language', 'isLogin', 'info', 'subjectType', 'loginAccount'])
  },
  // watch: {
  //   $route: function() {
  //     this.menuActive()
  //   }
  // },
  mounted() {
    if (this.subjectType == 'ACTOR') {
      this.name = this.info.userInfo.name
    } else {
      this.name = this.info.visitor.name
    }
  },
  methods: {
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        path = this.$route.meta.pPath
      }
      this.activeIndex = path
    },
    setLang(language) {
      this.$i18n.locale = language
      this.$store.commit('SET_LANGUAGE', language)
      location.reload()
    },
    async LogOut() {
      await this.$store.dispatch('LogOut').then(() => {
        this.loginSource({replaceStatus: true})
      })
    },
  }
}
</script>
<style lang="stylus">
link-color = $color-main
link-hover = $color-main-hover
.line-mar {
  color: $color-gray-d9 
}

.item .el-badge__content.is-dot{
    top: 9px !important;
    left: -17px !important;
}

.el-menu--horizontal .el-menu-item {
  padding: 0px 16px !important;
}

.login-info{
  display: block;
  margin-top: -2px;

  & > span.head-roles{
    display: block;
    margin-left: 0;
  }

  &.nav-login-info {
    margin-right: 12px;

    * {
      display: inline-block;
      vertical-align top;
    }

    a {
      margin-left: 12px;
      margin-right: 12px;
      color: $color-main;
    }

    & > span.head-roles{
      margin-left: 12px;
      display: inline-block;

      font {
        color: $color-main;
      }
    }
  }
}

a
  color link-color
  &:hover
    color link-hover
.dash-header
  position relative
  width 100%
  min-height 68px
  box-shadow 0 1px 10px -2px $box-shadow2
  .external_link
    display block
  .el-icon-arrow-down
    display none
.dash-header-inner
  max-width $container-width
  margin 0 auto
  padding 0 15px
  height 68px
  display flex
  align-items center
  justify-content space-between
  color $color-black-65
  font-weight 400
  line-height 20px
  .language-change {
    margin-left: 10px;
  }
  .welcome
    font-size 12px
    .dash-head-logo
      display inline-block
      height 59px
      width 219px
      img
        height 100%
    .head-roles
      i 
        font-style initial
      font
        color $color-blue
    *
      margin-right 12px
  nav
    font-size 12px
    display flex
    // display none
    align-items center
    a
      color $color-black-65
    a:hover
      color link-hover
    > a
      display inline-block
      padding 0 12.5px
      text-align center
      position relative
      &:before
        content ''
        position absolute
        right 0
        top 5px
        width 1px
        height 12px
        background $color-black-15
      &:last-child:before
        display none
    .iconfont
      margin-right 0
      margin-left: 0
      padding-top 4px
      width 25px
      font-size 25px
      color $color-main
      cursor pointer
      vertical-align -5px;
</style>
